import React from 'react';
import { ProgressIndicator, ProgressStep } from 'carbon-components-react';
import './Slider.scss';
import { segmentTracking } from '../../lib/tracker';
import { object, pageTitle } from '../../constants/default';

interface Step {
  value: number;
  label: string;
  desc: string;
}

interface SliderProps {
  steps: Step[];
  selectedStep: number;
  onStepChange: (step: number) => void;
}

const Slider: React.FC<SliderProps> = ({
  steps,
  selectedStep,
  onStepChange,
}) => {
  const handleStepClick = (value: number) => {
    onStepChange(value);
    segmentTracking('CTA Clicked', {
      pageTitle: pageTitle,
      object: object,
      resultValue: 'CTA clicked',
      CTA: 'Slider Option Change',
      location: 'Assessment',
      action: '',
      field: '',
    });
  };

  return (
    <div className="crat-progress-bar">
      <ProgressIndicator
        currentIndex={selectedStep}
        onChange={(e) => handleStepClick(e)}
        className="padding-0"
      >
        {steps.map((step, index) => (
          <ProgressStep
            key={index}
            complete={step.value <= selectedStep}
            index={step.value}
            description={step.desc}
            onClick={() => handleStepClick(step.value)}
            label={step.label}
            className={step.value === selectedStep ? 'progressStepActive' : ''}
          />
        ))}
      </ProgressIndicator>
    </div>
  );
};

export default Slider;
